<app-base-dialog
  [visible]="visible()"
  (visibleChange)="close()"
  [title]="
    'project.steps.invitationList.maxParticipantsDialog.title'
      | transloco: {maxParticipants: maxAllowedParticipants()}
  "
  testId="max-participants-dialog"
  width="400px"
  [dismissableMask]="false"
  [contentPadding]="false"
  titleClass="text-lg font-semibold"
  cancelLabel="common.ok"
>
  <p class="mb-7">
    {{
      'project.steps.invitationList.maxParticipantsDialog.message'
        | transloco: {maxParticipants: maxAllowedParticipants()}
    }}
  </p>
</app-base-dialog>
